import { AxiosInstance, AxiosResponse } from 'axios';
import { TCountry, TLocaleAPI } from '../types/locale';

export type TCityEndpoints = {
    get: (cityId: number) => Promise<AxiosResponse<TCountry>>;
};

export default (api: AxiosInstance, apiLocale: TLocaleAPI): TCityEndpoints => {
    const get = async (cityId: number): Promise<AxiosResponse<TCountry>> =>
        api.get<TCountry>(`/_svc/misc/v2/city/${cityId}`, { headers: { 'X-Locale': apiLocale } });

    return { get };
};
